/**
 * External dependencies.
 */
import { __, _x } from '@wordpress/i18n';
import {
	InspectorControls,
	useBlockProps,
	__experimentalUnitControl as UnitControl // eslint-disable-line
} from '@wordpress/block-editor';
import {
	ToggleControl,
	PanelBody,
	Notice,
	__experimentalToggleGroupControl as ToggleGroupControl, // eslint-disable-line
	__experimentalToggleGroupControlOption as ToggleGroupControlOption // eslint-disable-line
} from '@wordpress/components';

export default ( { attributes: { makefixed, blockstickyverposition, blockstickyverpositionoffset, blockmaxwidth, onlyavatar, avatarsize, menuopenverposition, menuopenhorposition, menuhorpositionoffset, menuverpositionoffset }, setAttributes } ) => {
	const blockProps = useBlockProps( {
		style: {
			fontFamily: 'var(--portal-font-family)',
		},
		className: makefixed ? 'suredash-portal__editor-profile suredash-profile--fixed portal-user-profiles-wrap portal-content' : 'suredash-portal__editor-profile portal-user-profiles-wrap portal-content',
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<ToggleControl
						label={ __( 'Sticky Position', 'suredash' ) }
						checked={ makefixed }
						onChange={ ( makefixed ) => setAttributes( { makefixed } ) } // eslint-disable-line
					/>

					{
						makefixed && (
							<>
								<ToggleGroupControl
									__nextHasNoMarginBottom
									label={ __( 'Sticky Vertically From', 'suredash' ) }
									value={ blockstickyverposition }
									onChange={ ( blockstickyverposition ) => setAttributes( { blockstickyverposition } ) } // eslint-disable-line
									isBlock
								>
									<ToggleGroupControlOption
										value="top"
										label={ _x(
											'Top',
											'Stick from top direction',
											'suredash'
										) }
									/>
									<ToggleGroupControlOption
										value="bottom"
										label={ _x(
											'Bottom',
											'Stick from bottom direction',
											'suredash'
										) }
									/>
								</ToggleGroupControl>

								<UnitControl
									label={ __( 'Position Offset', 'suredash' ) }
									labelPosition="top"
									__unstableInputWidth="80px"
									value={ blockstickyverpositionoffset }
									onChange={ ( blockstickyverpositionoffset ) => setAttributes( { blockstickyverpositionoffset } ) } // eslint-disable-line
								/>

								<UnitControl
									label={ __( 'Block Max Width', 'suredash' ) }
									labelPosition="top"
									__unstableInputWidth="80px"
									value={ blockmaxwidth }
									onChange={ ( blockmaxwidth ) => setAttributes( { blockmaxwidth } ) } // eslint-disable-line
								/>

								<Notice status="warning" className="suredash-settings-notice" isDismissible={ false }>
									{ __( 'If the block is stuck within the sidebar, adjust its width here to ensure it fits properly and maintains a better UI.', 'suredash' ) }
								</Notice>
							</>
						)
					}

					<br />

					<ToggleControl
						label={ __( 'Display only Avatar', 'suredash' ) }
						checked={ onlyavatar }
						onChange={ ( onlyavatar ) => setAttributes( { onlyavatar } ) } // eslint-disable-line
					/>

					<UnitControl
						label={ __( 'Avatar Size', 'suredash' ) }
						labelPosition="top"
						__unstableInputWidth="80px"
						value={ avatarsize }
						onChange={ ( avatarsize ) => setAttributes( { avatarsize } ) } // eslint-disable-line
					/>

					<ToggleGroupControl
						__nextHasNoMarginBottom
						label={ __( 'Menu Open Vertically', 'suredash' ) }
						value={ menuopenverposition }
						onChange={ ( menuopenverposition ) => setAttributes( { menuopenverposition } ) } // eslint-disable-line
						isBlock
					>
						<ToggleGroupControlOption
							value="top"
							label={ _x(
								'Top',
								'Open at top direction',
								'suredash'
							) }
						/>
						<ToggleGroupControlOption
							value="bottom"
							label={ _x(
								'Bottom',
								'Open at bottom direction',
								'suredash'
							) }
						/>
					</ToggleGroupControl>

					<UnitControl
						label={ __( 'Vertical Position Offset', 'suredash' ) }
						labelPosition="top"
						__unstableInputWidth="80px"
						value={ menuverpositionoffset }
						onChange={ ( menuverpositionoffset ) => setAttributes( { menuverpositionoffset } ) } // eslint-disable-line
					/>

					<ToggleGroupControl
						__nextHasNoMarginBottom
						label={ __( 'Menu Open Horizontally', 'suredash' ) }
						value={ menuopenhorposition }
						onChange={ ( menuopenhorposition ) => setAttributes( { menuopenhorposition } ) } // eslint-disable-line
						isBlock
					>
						<ToggleGroupControlOption
							value="left"
							label={ _x(
								'Left',
								'Open at left position',
								'suredash'
							) }
						/>
						<ToggleGroupControlOption
							value="right"
							label={ _x(
								'Right',
								'Open at right position',
								'suredash'
							) }
						/>
					</ToggleGroupControl>

					<UnitControl
						label={ __( 'Horizontal Position Offset', 'suredash' ) }
						labelPosition="top"
						__unstableInputWidth="80px"
						value={ menuhorpositionoffset }
						onChange={ ( menuhorpositionoffset ) => setAttributes( { menuhorpositionoffset } ) } // eslint-disable-line
					/>
				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				<style>
					{ `
						.suredash-profile--fixed.portal-user-profiles-wrap {
							${ blockstickyverposition }: ${ blockstickyverpositionoffset };
							max-width: ${ blockmaxwidth };
							margin: 0;
						}
					` }
				</style>

				<div className="portal-header-avatar-wrap" data-view="logged-in">
					{
						portal_blocks?.blocks_required_configs?.user_avatar && (
							<img src={ portal_blocks.blocks_required_configs.user_avatar } className="portal-user-avatar" style={ { maxWidth: avatarsize, width: avatarsize, maxHeight: avatarsize, height: avatarsize } } alt="SureDash user profile" />
						)
					}

					{
						! onlyavatar && (
							<>
								<div className="portal-user-settings">
									<div className="portal-user-details">
										<span className="portal-user-name"> { portal_blocks.blocks_required_configs.user_display_name } </span>
										<span className="portal-user-email"> { portal_blocks.blocks_required_configs.user_email } </span>
									</div>
								</div>

								<span className="portal-svg-icon portal-icon-sm">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-ellipsis-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
								</span>
							</>
						)
					}

				</div>
			</div>
		</>
	);
};
